export default "__VITE_ASSET__F9adD026__"